/**
 * 「已沖帳,鎖定」的判斷(規則本身出自 REQ-20260821001)。
 *
 * 抽成共用函式是 REQ-20260824009 的事:同一條規則現在有三個呼叫端 ——
 * 出貨管理列表(每列的動作)、列印預覽頁的「修改訂單」、編輯表單的唯讀模式。
 * 各自寫一份 `Number(x) > 0` 遲早會分岔,而分岔的症狀是「某個入口忘了鎖」。
 *
 * 收的是**字串金額**而不是整張單:列表的 `SalesOrderListItem` 與明細的
 * `SalesOrderDetail` 是兩個型別,收欄位才兩邊都用得上(金額一律是字串 Decimal)。
 *
 * 解除沖銷寫的是負金額的反向沖帳明細,所以這個數字**本來就是淨額** ——
 * 解完就回到 0,鎖跟著自動解開,不需要第二個「是否已解除」的旗標。
 */
export function isOrderSettled(settledAmount: string): boolean {
  return Number(settledAmount) > 0;
}
